import api from './api';
import { COMUM_ROUTE } from '../constants/apiRoutes';

export default {
	/* SELECTS DADOS PARAMETRIZADOS */
	findAllOrgaos() {
		return api.get(COMUM_ROUTE.FIND_ALL_ORGAOS);
	},

	findAllCategorias() {
		return api.get(COMUM_ROUTE.FIND_ALL_CATEGORIAS);
	},

	findAllSeveridades() {
		return api.get(COMUM_ROUTE.FIND_ALL_SEVERIDADES);
	},

	findAllUrgencias() {
		return api.get(COMUM_ROUTE.FIND_ALL_URGENCIAS);
	},

	findAllConfiancas() {
		return api.get(COMUM_ROUTE.FIND_ALL_CONFIANCAS);
	},

	/* SELECTS ANALISE */
	findAllOrigens() {
		return api.get(COMUM_ROUTE.FIND_ALL_ORIGENS);
	},

	findAllResponsaveis() {
		return api.get(COMUM_ROUTE.FIND_ALL_RESPONSAVEIS);
	},
};
